export default "__VITE_ASSET__CtdAZqW9__"